export const AiAgentsBuildGuide = () => (
  <section className="py-8 sm:py-12">
    <h2 className="text-2xl sm:text-3xl font-display font-bold text-foreground mb-6">How to Get Started</h2>
    <div className="space-y-4">
      {["1. Identify a repetitive task that takes >2 hours/week", "2. Map out every step in the current manual process", "3. Choose your tool: n8n (self-hosted), Make (easy), or custom code (flexible)", "4. Build the happy path first — handle edge cases later", "5. Test with real data, monitor failures, iterate"].map((step, i) => (
        <div key={i} className="bg-card rounded-xl border border-border p-4 flex items-center gap-4">
          <span className="w-8 h-8 rounded-full bg-primary/20 text-primary font-bold flex items-center justify-center shrink-0">{i + 1}</span>
          <span className="text-foreground">{step.substring(3)}</span>
        </div>
      ))}
    </div>
  </section>
);
